<template>
  <RCard class="orders">
    <AgGrid :options="gridOptions" :row-data="orders">
      <template #header>
        <div class="text-subtitle-1 text-secondary-2">Recent orders</div>
      </template>
    </AgGrid>
  </RCard>
</template>

<script>
import { associatedItemsRenderer, entityNameSorter, getProp, numericSorter } from '@lib/generic.utils'
import { agStartDateCol } from '@/ag-grid/ag-columns'
// Components
import AgGrid from '@/ag-grid/AgGrid'

export default {
  components: {
    AgGrid
  },

  inject: ['getOrders'],

  data: () => ({
    orders: null
  }),

  computed: {
    gridOptions() {
      return {
        columnDefs: [
          agStartDateCol({
            headerName: 'Date',
            field: 'date'
          }),

          {
            headerName: 'Sent by',
            field: 'created_by',
            comparator: entityNameSorter,
            cellRenderer: params => getProp(params.value, 'name'),
            tooltipValueGetter: params => getProp(params.value, 'name')
          },

          {
            headerName: 'Items',
            field: 'items_count',
            comparator: numericSorter,
            cellRenderer: params => associatedItemsRenderer(params.value),
            tooltipValueGetter: params => associatedItemsRenderer(params.value)
          }
        ],

        domLayout: 'autoHeight'
      }
    }
  },

  created() {
    this.getOrders().then(({ data }) => {
      this.orders = data.result
    })
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/mixins';

.orders {
  @include table-with-no-filters;
}
</style>
